import React, { Component } from 'react';
import orderService, { OrderCommitAction } from '../OrderService';
import { StepPanel } from '../../controls/StepPanel';
import { CustomizedStep1Page } from './CustomizedStep1Page';
import { CustomizedStep2Page } from './CustomizedStep2Page';
import { CustomizedStep3Page } from './CustomizedStep3Page';
import { CustomizedStep4Page } from './CustomizedStep4Page';
import ScanFileDialog from './../ScanFileDialog';
import authService from '../../api-authorization/AuthorizeService'
import { AccountGroup } from '../../infrastructure/AppConstants';

export class CustomizedSheet extends Component {
    constructor(props) {
        super(props);
        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleOnlySave = this.handleOnlySave.bind(this);
        this.handleReview = this.handleReview.bind(this);
        this.stepHeaders = ["DealerBaseInfo", "CustomerBaseInfo", "ProductType", "OptionsAndOthers"];
        this.stepSubTitles = ["DealerBaseInfoTitle", "CustomerBaseInfoTitle", "ProductTypeTitle", "OptionsAndOthersTitle"];
        this.stepRefs = [React.createRef(), React.createRef(), React.createRef(), React.createRef()];
        this.stepContents = [this.renderStep1(), this.renderStep2(), this.renderStep3(), this.renderStep4()];
    }

    handleBack(oldStep, newStep) {
    }

    async handleNext(oldStep, newStep) {
        //第一页dealerinfo，UI上修改直接影响model中数据，所以不用处理；
        //最后一页没有下一页按钮，这里也不用处理
        //2,3两页在店下一页按钮时更新数据
        if (oldStep === 1 && this.stepRefs[1].current) {
            var current = this.stepRefs[1].current;
            await orderService.updateCustomerInfo(current.customerRef.state);
            await orderService.updateHearingLossData(current.hearingLossRef.state);
        }
        if (oldStep === 2 && this.stepRefs[2].current) {
            await orderService.updateCustomizedMachineProductOptions(this.stepRefs[2].current.customizedMachineRef.state);
        }

        await orderService.save(OrderCommitAction.Save);
    }
    async handleSave() {
        if (this.stepRefs[1].current) {
            var current = this.stepRefs[1].current;
            await orderService.updateCustomerInfo(current.customerRef.state);
            await orderService.updateHearingLossData(current.hearingLossRef.state);
        }
        if (this.stepRefs[2].current) {
            await orderService.updateCustomizedMachineProductOptions(this.stepRefs[2].current.customizedMachineRef.state);
        }
        //如果再最后一页，需要更新数据
        if (this.stepRefs[3].current) {
            this.stepRefs[3].current.customizedMachineOtherRef.orderCommitting();
        }
        await orderService.save(OrderCommitAction.Save);
        window.history.back(-1);
    }
    async handleReview(isDigitalizedFileRequired) {
        if (this.stepRefs[1].current) {
            var current = this.stepRefs[1].current;
            await orderService.updateCustomerInfo(current.customerRef.state);
            await orderService.updateHearingLossData(current.hearingLossRef.state);
        }
        if (this.stepRefs[2].current) {
            await orderService.updateCustomizedMachineProductOptions(this.stepRefs[2].current.customizedMachineRef.state);
        }
        //如果再最后一页，需要更新数据
        if (this.stepRefs[3].current) {
            this.stepRefs[3].current.customizedMachineOtherRef.orderCommitting();
        }

        if (isDigitalizedFileRequired) {
            await orderService.save(OrderCommitAction.Save);
            this.scanFileDialog.open(OrderCommitAction.DealerReview);
            return;
        }
        await orderService.save(OrderCommitAction.DealerReview);
        window.history.back(-1);
    }

    async handleOnlySave() {
        if (this.stepRefs[1].current) {
            var current = this.stepRefs[1].current;
            await orderService.updateCustomerInfo(current.customerRef.state);
            await orderService.updateHearingLossData(current.hearingLossRef.state);
        }
        if (this.stepRefs[2].current) {
            await orderService.updateCustomizedMachineProductOptions(this.stepRefs[2].current.customizedMachineRef.state);
        }
        //如果再最后一页，需要更新数据
        if (this.stepRefs[3].current) {
            this.stepRefs[3].current.customizedMachineOtherRef.orderCommitting();
        }
        await orderService.save(OrderCommitAction.Save);
    }

    async handleFinish() {
        //如果再最后一页，需要更新数据
        if (this.stepRefs[3].current) {
            this.stepRefs[3].current.customizedMachineOtherRef.orderCommitting();
        }
        const accountGroup = authService.getCurrentUser().accountGroup;
        if (accountGroup == AccountGroup.DealerAdmin && this.props.model.attachmentFile) {
            await orderService.save(OrderCommitAction.Submit);
            window.history.back(-1);
        } else {
            await orderService.save(OrderCommitAction.Save);
            this.scanFileDialog.open();
        }
    }


    closeScanFileDialog(e) {
        this.scanFileDialog.close();
    }
    incrementCounter() {
        this.setState({
            currentCount: this.state.currentCount + 1
        });
    }
    renderStep1() {
        return <CustomizedStep1Page ref={this.stepRefs[0]} model={this.props.model} />;
    }

    renderStep2() {
        return <CustomizedStep2Page ref={this.stepRefs[1]} model={this.props.model} />;
    }

    renderStep3() {
        return <CustomizedStep3Page ref={this.stepRefs[2]} model={this.props.model} />;
    }

    renderStep4() {
        return <CustomizedStep4Page ref={this.stepRefs[3]} model={this.props.model} />;
    }


    render() {
        return (<div><StepPanel model={this.props.model} stepHeaders={this.stepHeaders}
            stepSubTitles={this.stepSubTitles}
            stepContents={this.stepContents}
            stepRefs={this.stepRefs}
            currentStep={0}
            onBack={this.handleBack}
            onNext={this.handleNext}
            onFinish={this.handleFinish}
            onSave={this.handleSave} onOnlySave={this.handleOnlySave} onReview={this.handleReview} />
            <ScanFileDialog onRef={(ref) => { this.scanFileDialog = ref }} leftRightOption={this.props.model.leftRightOption} id={this.props.id} onClose={this.closeScanFileDialog}></ScanFileDialog>
        </div>)
    }
}